import { map, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { RouterAction } from '@cbridge-packages/routing';
import { ShowUnmappedParam } from '../_helpers/showUnmappedSearchParam';
import { showUnmappedSelector } from '../_selectors/showUnmapped.selector';
import { UnmappedSymbolsToggleAction } from '../unmappedSymbolsToggle.action';

type IState = IGetSelectorStateType<typeof showUnmappedSelector>;

export const toggleUnmappedSymbolsEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(UnmappedSymbolsToggleAction.toggle),
  withLatestFrom(state$),
  map(([, state]) => {
    const currentShowUnmapped = showUnmappedSelector(state);

    if (currentShowUnmapped) {
      return RouterAction.removeParam(ShowUnmappedParam.name);
    }
    return RouterAction.addParam(ShowUnmappedParam.nameAndValue('true'));
  }),
);
